import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import classNames from "classnames";

import { useProductSliderContext } from "../productSlider.context";
import "./productSliderSkeleton.scss";

const ProductSkeleton = ({
    amountOfFeatures = 0
}: {
    showButton?: boolean;
    showCategoryLink?: boolean;
    amountOfFeatures?: number;
}) => (
    <div className="productTile product-tile--skeleton">
        <div className="productImage-wrapper">
            <div className="skeleton-product-tile__image" />
        </div>
        <h5 className="product-tile__title mb-md-0">
            <div className="skeleton-product-tile__title" />
        </h5>
        <div className="d-flex flex-wrap justify-content-between align-items-end my-2">
            <div></div>
            <div className="product-tile__price-block d-flex justify-content-end">
                <span className="price--medium">
                    <span className="skeleton-product-tile__price" />
                </span>
            </div>
        </div>
        {amountOfFeatures > 0 && (
            <div className="product-layout-description">
                <ul className="product-layout-description__list skeleton-product-tile__feature-list">
                    {[...Array(amountOfFeatures)].map((_, index) => (
                        <li key={index}>
                            <span className="skeleton-product-tile__feature" />
                        </li>
                    ))}
                </ul>
            </div>
        )}
    </div>
);

const ProductSliderSkeletonComponent = () => {
    const { source, title, productTileConfig } = useProductSliderContext();

    const isRecent = source === ProductSliderSources.Recent;

    return (
        <div className={isRecent ? "productSlider-recents" : ""}>
            <div className="row m-0 d-md-flex flex-row mb-3 mb-md-0">
                {title && (
                    <h2 className={classNames("mr-3 my-2 flex-shrink-1")}>
                        {title}
                    </h2>
                )}
            </div>
            <div className="product-tile__list--skeleton">
                <ProductSkeleton
                    amountOfFeatures={productTileConfig.amountOfFeatures}
                />
                <ProductSkeleton
                    amountOfFeatures={productTileConfig.amountOfFeatures}
                />
            </div>
        </div>
    );
};

export { ProductSliderSkeletonComponent };
